var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6071 14.5818L28.292 14.8193L28.3093 15.2135C28.3177 15.4057 28.3179 15.5911 28.3179 15.8047V15.8057C28.3267 21.9125 23.849 28.8499 15.7694 28.8499C14.3124 28.8499 12.8704 28.5842 11.5092 28.0724C13.1371 27.77 14.6795 27.0587 15.9937 25.9856L17.5755 24.694L15.5337 24.6548C14.2475 24.6301 13.0669 23.95 12.3576 22.8648C12.7334 22.8409 13.1067 22.7755 13.4714 22.6682L13.4089 21.2137C11.9594 20.9195 10.8112 19.7893 10.4115 18.3284C10.8019 18.4331 11.2044 18.4927 11.6104 18.5032L14.1186 18.5682L12.0575 17.1374C10.6457 16.1572 10.02 14.3648 10.4226 12.7102C12.8843 15.3341 16.2223 16.9097 19.7855 17.1008L20.7758 17.1539L20.5572 16.1865C20.2343 14.7581 20.6768 13.2579 21.7022 12.2512C23.2756 10.7173 25.7502 10.7933 27.2451 12.4317L27.5313 12.7454L27.9475 12.6614C28.2269 12.605 28.5037 12.5361 28.7769 12.4551C28.6327 12.5763 28.48 12.6873 28.3198 12.787L28.8085 14.1681C28.932 14.1528 29.0551 14.135 29.1778 14.115C28.994 14.278 28.8036 14.4336 28.6071 14.5818Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.e009226ef4287b9f698e5c09664b79d2.svg";
export { ForwardRef as ReactComponent };